import { Avatar, Icon, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import { H, V } from '../../common/Layout';
import { ReferenceField } from '../../common/reference/reference';
import { useStyling } from '../../common/Theme';
import { Icons } from '../../common/icons/Icons';

type ProductOptionType = {
    id: string;
    name: string;
    ownerOrganizationName: string;
    type: string;
    categories: Array<Object>;
    reference: ReferenceField;
};
export const getOption = (item: ProductOptionType) => {
    return {
        id: item.id,
        label: item.name,
        ownerOrganizationName: item.ownerOrganizationName,
        type: item.type,
        categories: item.categories,
        ref: item.reference
    };
};

export default ({ option }) => {
    const { theme } = useStyling();
    const { label, ownerOrganizationName, type, categories } = option;
    const categoriesValue = categories ? categories.map((category) => category.value).join(', ') : '';
    const subLabel = [ownerOrganizationName, categoriesValue].filter(Boolean).join('; ');
    const catalogTypes = {
        Facility: Icons.Facilities,
        Service: Icons.Services,
        Product: Icons.Products,
        Equipment: Icons.Equipements,
        Crew: Icons.Crew,
        Default: Icons.BuildCircleOutlined
    };
    const Icon = catalogTypes[type] || catalogTypes['Default'];

    return (
        <H>
            <Avatar sx={{ bgcolor: grey[300], color: 'white' }}>
                {<Icon sx={{ color: theme.palette.inactive.contrastText }} />}
            </Avatar>
            <V sx={{ width: '100%', ml: 2 }}>
                <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
                    {label}
                </Typography>
                <Typography sx={{ fontWeight: '300' }} color={theme.palette.inactive.main} variant="subtitle2">
                    {subLabel}
                </Typography>
            </V>
        </H>
    );
};
